import React from "react";

import AppStoreLink from "./AppStoreLink";
import GooglePlayStoreLink from "./GooglePlayStoreLink";

export default function MobileStoreLinks({
  appStoreHref,
  googlePlayStoreHref,
}: {
  appStoreHref?: string;
  googlePlayStoreHref?: string;
}) {
  return (
    <div className='tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row'>
      {appStoreHref && <AppStoreLink href={appStoreHref} />}
      {googlePlayStoreHref && <GooglePlayStoreLink href={googlePlayStoreHref} />}
    </div>
  );
}
